import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getUsers = createAsyncThunk('users/getUsers',
  async (_, { rejectWithValue }) => {
    try {
      const { data: { data: users } } = await authGet('/users');
      return users;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getUsers;
